import { c } from './react-compiler-runtime-19061925.js';
import { useLayoutEffect } from '@react-aria/utils';
import { useState, isValidElement, cloneElement } from 'react';

// TODO: replace instances of this with CSS `:has()` when it's supported
// https://developer.mozilla.org/en-US/docs/Web/CSS/:has
// https://caniuse.com/#feat=css-has
// https://bugzilla.mozilla.org/show_bug.cgi?id=418039
function useHasChild(query, ref) {
  const $ = c(6);
  const [hasChild, setHasChild] = useState(true);
  let t0;
  if ($[0] !== ref.current || $[1] !== query) {
    t0 = () => {
      setHasChild(!!(ref.current && ref.current.querySelector(query)));
    };
    $[0] = ref.current;
    $[1] = query;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== query || $[4] !== ref) {
    t1 = [setHasChild, query, ref];
    $[3] = query;
    $[4] = ref;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useLayoutEffect(t0, t1);
  return hasChild;
}

/**
 * Clone a React element, with optional props. If the value is
 * not a valid React element, return null.
 */
function cloneValidElement(child, props) {
  if (! /*#__PURE__*/isValidElement(child)) {
    return null;
  }
  return /*#__PURE__*/cloneElement(child, props);
}

export { cloneValidElement as c, useHasChild as u };
